import { createContext, useContext } from 'react';

export const PageContext = createContext({
  moveToPage: () => {},
  id: null,
  setId: () => {},
});

export const usePage = () => useContext(PageContext);
